var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "attachment-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.6599 9.10287L10.1614 16.6303C8.45614 18.3422 5.68605 18.3475 3.97422 16.6422C2.26239 14.937 2.25706 12.1669 3.96231 10.4551L11.4608 2.92761C12.5977 1.78639 14.4444 1.78284 15.5856 2.91967C16.7268 4.05651 16.7304 5.90323 15.5936 7.04445L8.38909 14.2767C7.82067 14.8473 6.89731 14.8491 6.3267 14.2807C5.75609 13.7123 5.75431 12.7889 6.32273 12.2183L12.645 5.87162",
    stroke: "#B8C5CC",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.55458b727901bf7872c9a924c5ebfa97.svg";
export { ForwardRef as ReactComponent };